import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {getUserCountryCode} from 'modules/meta/selectors'
import {
  getRoomDetailOverlay,
  getRoomDetailOverlayVisibility
} from 'modules/overlay/selectors'
import {hideOverlay} from 'modules/overlay/slice'
import {
  getAccommodationPageHotel,
  getFAQData,
  getHotelRoomById
} from 'modules/searchApi/selectors'
import {imageProvider} from 'utils/imageProvider'

import {Card} from '@vio/atlas/src/components/designSystem/Card'
import {cssTheme} from '@vio/atlas/src/themes'
import {useBrand} from '@vio/core/src/_web/brand/hooks/useBrand'
import {RoomDetailsOverlay} from '@vio/shared/src/accommodation/RoomDetailsOverlay'

import {
  DatelessCTA,
  DatelessCTAVariant
} from '../Offers/DatelessCTA/DatelessCTA'

const FooterCard = styled(Card)`
  border-top: 1px solid ${cssTheme.colors.border.neutral.secondary};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: ${cssTheme.layout.spacing.s500};
  box-sizing: border-box;
`

export const RoomsDetailOverlayDateless = () => {
  const {brand} = useBrand()
  const roomsDetailsOverlayState = useSelector(getRoomDetailOverlay)
  const isRoomsDetailsOverlayOpen = useSelector(getRoomDetailOverlayVisibility)
  const {hotelId, roomId} = roomsDetailsOverlayState || {}
  const faqData = useSelector(state => getFAQData(state, hotelId))
  const datelessRoom = useSelector(state =>
    getHotelRoomById(state, hotelId, roomId)
  )
  const hotelInfo = useSelector(getAccommodationPageHotel)
  const childPolicy = hotelInfo?.childPolicy
  const dispatch = useDispatch()
  const userCountry = useSelector(getUserCountryCode)
  const isOverlayOpen = isRoomsDetailsOverlayOpen && Boolean(datelessRoom)

  return (
    <RoomDetailsOverlay
      isOpen={isOverlayOpen}
      room={datelessRoom}
      onClose={() => dispatch(hideOverlay())}
      imageProvider={imageProvider}
      userCountry={userCountry}
      childPolicy={childPolicy}
      brand={brand}
      faqData={faqData}
      footerSlot={
        <FooterCard>
          <DatelessCTA variant={DatelessCTAVariant.RoomListing} />
        </FooterCard>
      }
    />
  )
}
